<!-- 
    描述：新增、编辑、查看委托审计
    时间：2021/04/19
    Created by zl
-->
<template>
	<div class="entrust-layout">
		<div class="text-center entrust-layout-header">
			<img :src="require('@/assets/images/step' + activeNum + '.png')" />
		</div>
		<!-- 步骤一 -->
		<template v-if="activeNum == 1">
			<div class="container">
				<el-row :gutter="20">
					<el-col :span="16">
						<el-col :span="24"
								class="pd0">
							<div class="green">
								<span>项目信息</span>
							</div>
							<el-col :span="24"
									class="container-box project-msg">
								<el-form :model="projectForm"
										 size="small"
										 class="pdl10"
										 label-width="auto"
										 label-position="left">
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label="工程项目名称：">
												<div class="text-color text-overflow">
													<TextTooltip :content="projectForm.sname"
																 :refName="'projectFormSname'"></TextTooltip>
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="项目编号：">
												<div class="text-color text-overflow-by">
													{{ projectForm.proNo }}
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label="项目类型：">
												<div class="text-color text-overflow-by">
													{{ projectForm.proTypeName }}
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item :label="
                                                    projectForm.hasSerial === 1
                                                        ? '建设任务书编号：'
                                                        : '无任务书编号原因：'
                                                ">
												<div class="text-color text-overflow-by"
												v-if="projectForm.hasSerial === 1">
													{{ projectForm.assignNo }}
												</div>
												<div class="text-color text-overflow">
													<TextTooltip v-if="!projectForm.hasSerial"
																 :content="projectForm.reason"
																 :refName="'projectFormreason111'"></TextTooltip>
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label="项目所在区域：">
												<div class="text-color text-overflow-by">
													{{ projectForm.area }}
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="项目地址：">
												<div class="text-color text-overflow">
													<TextTooltip :content="projectForm.address"
																 :refName="'projectFormaddress'"></TextTooltip>
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label="项目年份：">
												<div class="text-color text-overflow-by">
													{{ projectForm.proYear }}
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="项目造价区间：">
												<div class="text-color text-overflow-by">
													{{ projectForm.intervalPrice }}
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label="计划开工时间：">
												<div class="text-color text-overflow-by">
													{{
                                                        projectForm.planStartTime &&
                                                        projectForm.planStartTime.length >
                                                            10
                                                            ? projectForm.planStartTime.substr(
                                                                  0,
                                                                  10
                                                              )
                                                            : "暂无"
                                                    }}
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="计划竣工时间：">
												<div class="text-color text-overflow-by">
													{{
                                                        projectForm.planEndTime &&
                                                        projectForm.planEndTime.length >
                                                            10
                                                            ? projectForm.planEndTime.substr(
                                                                  0,
                                                                  10
                                                              )
                                                            : "暂无"
                                                    }}
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label="立项审批概算价：">
												<div class="text-color text-overflow-by">
													{{
                                                        projectForm.estimatePrice
                                                            ? projectForm.estimatePrice +
                                                              "  万元"
                                                            : "暂无"
                                                    }}
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="建设工程概算价：">
												<div class="text-color text-overflow-by">
													{{
                                                        projectForm.buget
                                                            ? projectForm.buget + "  万元"
                                                            : "暂无"
                                                    }}
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<el-form-item label="项目概况：">
												<div class="text-color text-overflow-by">
													{{ projectForm.projectSurvey }}
												</div>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</el-col>
						</el-col>
						<el-col :span="24"
								class="pd0">
							<div class="green">
								<span>参建单位信息</span>
							</div>
							<el-col :span="24"
									class="container-box">
								<vxe-table align="center"
										   auto-resize
										   border
										   :data="contractorsData"
										   highlight-hover-row
										   highlight-current-row
										   size="small"
										   show-overflow="tooltip"
										   show-header-overflow="tooltip">
									<vxe-table-column field="limitName"
													  title="单位类型"></vxe-table-column>
									<vxe-table-column field="sname"
													  title="单位名称">
										<template #default="{ row }">
											<el-tooltip effect="dark"
														:content="row.sname"
														placement="top">
												<span class="vxe-cell--label">{{
                                                    row.shortName
                                                }}</span>
											</el-tooltip>
										</template>
									</vxe-table-column>
									<vxe-table-column field="leaderName"
													  title="项目负责人"></vxe-table-column>
									<vxe-table-column field="phone"
													  title="负责人联系方式"></vxe-table-column>
								</vxe-table>
							</el-col>
						</el-col>
						<el-col :span="24"
								class="pd0">
							<div class="green">
								<span>标段信息</span>
							</div>
							<el-col :span="24"
									class="container-box project-msg">
								<el-col :span="6">
									<p class="msg-show flex">
										标段编号：
										<span class="text-color text-overflow">
											<TextTooltip :content="sectionForm.packNo"
														 :refName="'sectionFormPackNo'"></TextTooltip>
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<div class="msg-show flex">
										<p>标段名称：</p>
										<p class="text-color text-overflow">
											<TextTooltip :content="sectionForm.sname"
														 :refName="'sectionFormSname'"></TextTooltip>
										</p>
									</div>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										标段包类型：
										<span class="text-color">
											{{ sectionForm.packTypeName }}
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										合同工期：
										<span class="text-color">
											{{ sectionForm.duration + ' 天' || '' }}
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show flex">
										标段负责人：
										<span class="text-color text-overflow">
											<TextTooltip :content="sectionForm.packPrincipalName"
														 :refName="'sectionFormPackPrincipalName'"></TextTooltip>
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show flex">
										标段负责人联系方式：
										<span class="text-color text-overflow">
											<TextTooltip :content="sectionForm.constract"
														 :refName="'sectionFormConstract'"></TextTooltip>
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										标段预算金额：
										<span class="text-color">
											{{ sectionForm.bugetValue + ' 万元' || '' }}
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show flex ">
										标段建安工程概算价：
										<span class="text-color text-overflow">
											<TextTooltip :content="sectionForm.estimatePriceValue + ' 万元'"
														 :refName="'sectionFormEstimatePriceValue'"></TextTooltip>
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										招标控制价：
										<span class="text-color">
											{{ sectionForm.controlPriceValue + ' 万元' }}
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										预备金/暂列金：
										<span class="text-color">
											{{ sectionForm.reservePriceValue + ' 万元' }}
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										合同价：
										<span class="text-color">
											{{ sectionForm.contractPriceValue + ' 万元' }}
										</span>
									</p>
								</el-col>
								<el-col :span="6">
									<p class="msg-show text-overflow">
										中标价：
										<span class="text-color">
											{{ sectionForm.bidPriceValue + ' 万元' }}
										</span>
									</p>
								</el-col>
								<el-col :span="24">
									<div class="msg-show flex">
										<p>标段关联单位：</p>
										<p class="text-color text-overflow">
											<TextTooltip :content="sectionForm.relateUnitsName"
														 :refName="'sectionFormRelateUnitsName'"></TextTooltip>
										</p>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="msg-show flex">
										<p>标段（包）内容建设与规模：</p>
										<p class="text-color text-overflow">
											<TextTooltip :content="sectionForm.content"
														 :refName="'sectionFormContent'"></TextTooltip>
										</p>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="msg-show flex">
										<p>备注说明：</p>
										<p class="text-color"
										   style="word-break: break-all">
											{{ sectionForm.remark }}
										</p>
									</div>
								</el-col>
							</el-col>
						</el-col>
					</el-col>
					<el-col :span="8"
							class="pd0">
						<div class="green">
							<span>项目资料</span>
						</div>
						<el-col :span="24"
								class="container-box">
							<vxe-table align="center"
									   auto-resize
									   border
									   :data="projectFiles"
									   row-id="id"
									   highlight-hover-row
									   highlight-current-row
									   size="small"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip"
									   :tree-config="{ children: 'children', expandAll: true }">
								<vxe-table-column field="sname"
												  title="资料清单"
												  tree-node
												  header-align="center"
												  align="left">
									<template #default="{ row }">
										<span class="vxe-cell--label">
											<i v-if="row.level < 3"
											   class="el-icon-folder-opened mr5"></i>
											<i v-else
											   class="el-icon-tickets mr5"></i>{{ row.sname }}
										</span>
									</template>
								</vxe-table-column>
								<vxe-table-column title="附件"
												  width="150">
									<template v-slot="{ row }">
										<span v-if="row.fileList.length > 0"
											  class="blue-text vxe-cell--label"
											  @click="viewFile(row)">
											查看（共{{ row.fileList.length }}个文件）
										</span>
										<span v-else>-</span>
									</template>
								</vxe-table-column>
							</vxe-table>
						</el-col>
					</el-col>
				</el-row>
			</div>
		</template>

		<!-- 步骤二 -->
		<template v-else>
			<div class="container">
				<el-row>
					<el-col :span="24"
							class="green flex">
						<span>委托标段</span>
					</el-col>
					<el-col :span="24"
							class="container-box">
						<el-col :span="8">
							<div class="msg-show flex">
								<p>标段名称：</p>
								<p class="text-color text-overflow-by">
									{{
                                        projectRow.packName == null
                                            ? projectRow.sname
                                            : projectRow.packName
                                    }}
								</p>
							</div>
						</el-col>
						<el-col :span="8">
							<p class="msg-show">
								标段编号：
								<span>{{ projectRow.packNo }}</span>
							</p>
						</el-col>
						<el-col :span="8">
							<p class="msg-show">
								委托任务类型：
								<span style="color: #60adf9"
									  v-if="projectRow.taskType">
									{{
                                        projectRow.taskType == "1006004001"
                                            ? "跟踪审计"
                                            : "结算审计"
                                    }}
								</span>
								<span style="color: #60adf9"
									  v-else>{{
                                    projectRow.taskTypeName
                                }}</span>
							</p>
						</el-col>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24"
							class="green">
						<span>委托报审内容</span>
					</el-col>
					<el-col :span="24"
							class="container-box entrust-msg">
						<el-form ref="elForm"
								 :model="formData"
								 :rules="rules"
								 size="small"
								 label-width="140px">
							<el-row>
								<el-col :span="13">
									<el-form-item label="委托方式"
												  prop="entrustType">
										<el-radio-group v-model.number="formData.entrustType"
														size="medium"
														@change="radioChange">
											<el-radio :label="0">自行委托</el-radio>
											<el-radio :label="1">委托审计机关</el-radio>
										</el-radio-group>
									</el-form-item>
								</el-col>
								<el-col :span="13">
									<el-form-item :label="
                                            formData.entrustType == 0
                                                ? '委托协审单位'
                                                : '委托审计单位'
                                        "
												  prop="entrustUnit">
										<el-select v-model="formData.entrustUnit"
												   :placeholder="
                                                formData.entrustType == 0
                                                    ? '请选择委托协审单位'
                                                    : '请选择委托审计单位'
                                            "
												   filterable
												   @change="utilChange">
											<el-option v-for="(item, index) in unitList"
													   :key="'unitList' + index"
													   :label="item.sname"
													   :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="13">
									<el-form-item label="审计单位类型"
												  required>
										<el-input v-model="formData.utilType"
												  placeholder="请输入审计单位类型"
												  disabled>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="13"
										v-if="formData.entrustType == 0">
									<el-form-item label="协审单位确定方式"
												  prop="confirmType">
										<el-select v-model="formData.confirmType"
												   placeholder="请选择协审单位确定方式">
											<el-option v-for="(item, index) in projectDict.qrfs"
													   :key="'confirmType' + index"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="13"
										v-if="showType == '1006004002'">
									<el-form-item label="结算报审价"
												  prop="auditPrice"
												  :rules="moneyRule">
										<el-input v-model="formData.auditPrice"
												  type="number"
												  min="0"
												  title=""
												  class="money-input-inner"
												  placeholder="请输入结算报审价">
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="13">
									<el-form-item label="审计要求完成时间"
												  prop="finishTime">
										<el-date-picker v-model="formData.finishTime"
														format="yyyy-MM-dd"
														value-format="yyyy-MM-dd"
														placeholder="请选择审计要求完成时间"
														clearable></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="13">
									<el-form-item label="标段状态"
												  prop="status">
										<el-select v-model.number="formData.status"
												   placeholder="请选择标段状态">
											<el-option :label="
                                                    showType == '1006004002'
                                                        ? '已竣工'
                                                        : '已开工'
                                                "
													   :value="1"></el-option>
											<el-option :label="
                                                    showType == '1006004002'
                                                        ? '未竣工'
                                                        : '未开工'
                                                "
													   :value="0"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="13"
										v-if="showType == '1006004002'">
									<el-form-item :label="
                                            formData.status == 0
                                                ? '计划竣工时间'
                                                : '实际竣工时间'
                                        "
												  prop="completeTime">
										<el-date-picker v-model="formData.completeTime"
														format="yyyy-MM-dd"
														value-format="yyyy-MM-dd"
														placeholder="请选择时间"
														clearable></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="13"
										v-if="showType == '1006004001'">
									<el-form-item :label="
                                            formData.status == 0
                                                ? '计划开工时间'
                                                : '实际开工时间'
                                        "
												  prop="completeTime">
										<el-date-picker v-model="formData.completeTime"
														format="yyyy-MM-dd"
														value-format="yyyy-MM-dd"
														placeholder="请选择时间"
														clearable></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="13"
										v-if="showType == '1006004002'">
									<el-form-item label="是否有甩项"
												  prop="hasJilt">
										<vxe-switch v-model="formData.hasJilt"
													close-label="否"
													:close-value="0"
													open-label="是"
													:open-value="1"
													@change="hasJiltChange">
										</vxe-switch>
									</el-form-item>
								</el-col>
								<el-col :span="13"
										v-if="
                                        showType == '1006004002' && formData.hasJilt == 1
                                    ">
									<el-form-item label="甩项金额"
												  prop="jiltAmount"
												  :rules="money1Rule">
										<el-input v-model="formData.jiltAmount"
												  placeholder="请输入甩项金额"
												  type="number"
												  min="0"
												  title=""
												  class="money-input-inner">
											<template slot="append">元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="13">
									<el-form-item label="备注">
										<el-input v-model="formData.remark"
												  type="textarea"
												  placeholder="请简单描述委托要求"
												  maxlength="200"
												  show-word-limit
												  :autosize="{ minRows: 5 }"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24"
							class="green">
						<span>委托报审资料</span>
					</el-col>
					<el-col :span="24"
							class="container-box">
						<el-button type="primary"
								   size="small"
								   class="mb10"
								   @click="addFile">选择报审资料</el-button>
						<el-select v-model="openLevel"
								   size="small"
								   class="ml10"
								   @change="levelChange"
								   v-if="searchData.length > 0">
							<el-option v-for="item in levelList"
									   :key="item.value"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
						<div class="h400">
							<vxe-table v-if="searchData.length > 0"
									   align="center"
									   auto-resize
									   border
									   ref="selectData"
									   :data="searchData"
									   :loading="tableLoading"
									   row-id="templateId"
									   height="100%"
									   highlight-hover-row
									   highlight-current-row
									   size="small"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip"
									   :tree-config="{ children: 'children', expandAll: true }">
								<vxe-table-column field="sname"
												  title="资料清单"
												  tree-node
												  header-align="center"
												  align="left">
									<template #default="{ row }">
										<span class="vxe-cell--label">
											<i v-if="row.level < 3"
											   class="el-icon-folder-opened mr5"></i>
											<i v-else
											   class="el-icon-tickets mr5"></i>{{ row.sname }}
										</span>
									</template>
								</vxe-table-column>
								<vxe-table-column title="附件"
												  header-align="center"
												  align="left">
									<template #default="{ row }"
											  class="text-left">
										<div style="overflow-x: auto">
											<span v-for="(item, index) in row.fileList"
												  :key="item.id"
												  class="blue vxe-cell--label">
												<template v-if="item.checked">
													<FileName :fileName="item.fileName"
															  :filePath="item.filePath"
															  :fileSize="item.fileSize"></FileName>
													{{
                                                        index === row.fileList.length - 1
                                                            ? ""
                                                            : ","
                                                    }}
												</template>
											</span>
										</div>
									</template>
								</vxe-table-column>
							</vxe-table>
							<div class="no-data"
								 v-else>
								<div>
									<i class="el-icon-tickets"></i>
								</div>
								暂无资料
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24"
							class="green">
						<span>委托历史记录</span>
					</el-col>
					<el-col :span="24"
							class="container-box">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="historyData"
								   highlight-hover-row
								   highlight-current-row
								   size="small"
								   show-overflow="tooltip"
								   show-header-overflow="tooltip">
							<vxe-table-column field="entrustTime"
											  title="委托日期"></vxe-table-column>
							<vxe-table-column field="auditTypeName"
											  title="委托审计任务类型"></vxe-table-column>
							<vxe-table-column field="unitName"
											  title="委托单位">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.unitName"
												placement="top">
										<span class="vxe-cell--label">{{
                                            row.unitShortName
                                        }}</span>
									</el-tooltip>
								</template>
							</vxe-table-column>
							<vxe-table-column field="unitTypeName"
											  title="委托单位类型"></vxe-table-column>
							<vxe-table-column field="statusName"
											  title="状态"></vxe-table-column>
						</vxe-table>
					</el-col>
				</el-row>
			</div>
		</template>

		<!-- 返回按钮 -->
		<div class="right-btns">
			<template v-if="activeNum == 1">
				<el-button size="mini"
						   @click="doEdit">修改信息</el-button>
				<el-button type="primary"
						   size="mini"
						   @click="nextStep">确认信息</el-button>
			</template>
			<template v-else>
				<el-button size="mini"
						   @click="activeNum = 1">返回</el-button>
				<el-button size="mini"
						   @click="backHome">取消</el-button>
				<el-button type="primary"
						   size="mini"
						   :loading="btnLoading"
						   @click="doAudit">提交审核</el-button>
			</template>
		</div>

		<!-- 查看、上传弹窗 -->
		<el-dialog :title="dialog.title"
				   :visible.sync="dialog.show"
				   width="1200px"
				   :close-on-click-modal="false"
				   center
				   @closed="doCancel"
				   v-if="dialog.show">
			<template v-if="dialog.type == 'view'">
				<vxe-table align="center"
						   border
						   :data="viewData"
						   resizable
						   row-id="templateId"
						   highlight-current-row
						   highlight-hover-row
						   show-overflow="tooltip"
						   show-header-overflow="tooltip">
					<vxe-table-column type="seq"
									  title="序号"
									  width="70"></vxe-table-column>
					<vxe-table-column field="fileName"
									  title="资料名称"
									  header-align="center"
									  align="left">
						<template #default="{ row }">
							<FileName :fileName="row.fileName"
									  :filePath="row.filePath"
									  :fileSize="row.fileSize"></FileName>
						</template>
					</vxe-table-column>
					<vxe-table-column field="redactUnit"
									  title="文件编制单位"
									  header-align="center"
									  align="left"></vxe-table-column>
					<vxe-table-column field="createUser"
									  title="上传人"></vxe-table-column>
					<vxe-table-column field="upUnit"
									  title="上传单位"
									  min-width="150px">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.upUnit"
										placement="top">
								<span>{{ row.shortName }}</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="createDate"
									  title="上传时间"></vxe-table-column>
				</vxe-table>
			</template>
			<template v-if="dialog.type == 'upload'">
				<p class="mb10">
					请将需要上传的文件在此窗口一次性操作完毕，窗口关闭后之前上传的文件将会被覆盖
				</p>
				<myUpload list-type="table"
						  ref="fileUpload"
						  :createUser="userInfo.sname"
						  :createCompany="upUnit"
						  :shortName="shortName"
						  :aid="uploadData.id"
						  tableName="bus_project"
						  assortment="project_file"
						  uploadType="0"></myUpload>
			</template>
			<div slot="footer"
				 v-if="dialog.type == 'upload'">
				<el-button class="btn"
						   @click="doCancel">取 消</el-button>
				<el-button class="btn"
						   type="primary"
						   :loading="uploadLoaing"
						   @click="doUpload">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 选择报审资料弹窗 -->
		<el-dialog :title="addDialog.title"
				   :visible.sync="addDialog.show"
				   width="1200px"
				   :close-on-click-modal="false"
				   center>
			<vxe-table align="center"
					   border
					   :data="reportFileData"
					   resizable
					   row-id="templateId"
					   height="450px"
					   ref="reportTable"
					   :loading="reportLoading"
					   highlight-current-row
					   highlight-hover-row
					   show-overflow="tooltip"
					   show-header-overflow="tooltip"
					   :tree-config="{ children: 'children', expandAll: true }"
					   :checkbox-config="{ checkRowKeys: checkBoxList }"
					   @checkbox-all="selectAllEvent"
					   @checkbox-change="selectChangeEvent">
				<vxe-table-column type="checkbox"
								  width="60"></vxe-table-column>
				<vxe-table-column type="seq"
								  title="序号"
								  width="70"></vxe-table-column>
				<vxe-table-column field="sname"
								  title="资料清单"
								  tree-node
								  header-align="center"
								  align="left"
								  width="200px">
					<template #default="{ row }">
						<span class="vxe-cell--label">
							<i v-if="row.level < 3"
							   class="el-icon-folder-opened mr5"></i>
							<i v-else
							   class="el-icon-tickets mr5"></i>{{ row.sname }}
						</span>
					</template>
				</vxe-table-column>
				<vxe-table-column field="fileList"
								  title="资料名称">
					<template #default="{ row }">
						<div v-if="row.fileList.length > 0"
							 class="text-left overflow-x">
							<span v-for="item in row.fileList"
								  :key="item.id">
								<el-checkbox v-model="item.checked"
											 class="mr10">{{
                                    item.fileName
                                }}</el-checkbox>
							</span>
						</div>
						<span v-else>-</span>
					</template>
				</vxe-table-column>
				<vxe-table-column field="upFlag"
								  title="是否需要上传"
								  width="110">
					<template #default="{ row }">
						{{ row.upFlag == 1 ? "是" : "否" }}
					</template>
				</vxe-table-column>
				<vxe-table-column title="操作"
								  width="120">
					<template #default="{ row }">
						<el-button type="primary"
								   class="table-btn"
								   size="mini"
								   plain
								   round
								   icon="el-icon-upload"
								   v-if="row.upFlag == 1"
								   @click="uploadFile(row)">上传</el-button>
					</template>
				</vxe-table-column>
			</vxe-table>
			<div slot="footer">
				<el-button class="btn"
						   @click="addDialog.show = false">取 消</el-button>
				<el-button class="btn"
						   type="primary"
						   @click="doSelect">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import * as API from 'api/projectManage/ProjectIndex'
import { mapState } from 'vuex'
import AddressForm from 'components/addressForm/addressForm'
import VUE_CONFIG from '../../../vue.config.js'
import TextTooltip from '@/views/Common/TextTooltip'
import { previewUrl } from '../../utils/tools'
export default {
	name: 'CommissionDetails',
	components: { AddressForm, TextTooltip },
	props: {},
	data() {
		return {
			activeNum: 1, // 步骤
			projectForm: {}, // 项目信息
			sectionForm: {}, //标段信息
			contractorsData: [], // 参建单位信息
			projectFiles: [], // 项目资料
			sectionFiles: [], //标段资料
			historyData: [], //委托历史记录
			unitList: [], //委托协审单位
			//委托报审内容表单
			formData: {
				entrustType: 0, //委托方式 0：自行委托   1：委托审计中心
				entrustUnit: '', //委托协审单位/委托审计中心
				utilType: '', //审计单位类型
				auditPrice: '', //结算报审价
				completeTime: '', //计划/实际竣工(开工)时间
				finishTime: '', //要求完成时间
				status: 0, //标段状态
				hasJilt: 1, //是否有甩项 0：否 1：是
				jiltAmount: '', //甩项金额
				remark: '', //备注
				confirmType: '', //协审单位确定方式
			},
			rules: {
				entrustType: [{ required: true, message: '不能为空...' }],
				entrustUnit: [{ required: true, message: '不能为空...' }],
				status: [{ required: true, message: '不能为空...' }],
				finishTime: [{ required: true, message: '不能为空...' }],
				completeTime: [{ required: true, message: '不能为空...' }],
				auditPrice: [{ required: true, message: '不能为空...' }],
				hasJilt: [{ required: true, message: '不能为空...' }],
				jiltAmount: [{ required: true, message: '不能为空...' }],
				confirmType: [{ required: true, message: '不能为空...' }],
			},
			showType: '', //是跟踪审计 还是结算审计
			taskId: '', // 委托任务内容id
			packId: '', //标段id
			btnLoading: false,
			dialog: {
				title: '',
				show: false,
				type: '',
			},
			addDialog: {
				title: '',
				show: false,
				type: '',
			},
			reportFileData: [], //报审资料
			viewData: [], //查看资料
			upUnit: '', //上传单位全称
			shortName: '', //简称
			uploadData: {}, //上传
			searchData: [],
			tableLoading: false, //选中的资料table loading
			uploadLoaing: false, //上传按钮loading
			reportLoading: false, // 报审资料loading
			checkBoxList: [], //checkbox默认选中
			moneyRule: [
				{ required: true, message: '不能为空...' },
				{
					pattern: /(^[\d]|^[1-9][\d]{0,8})($|[\.][\d]{0,4}$)/,
					message:
						'请填写正确的金额，不能为负数，小数点前最多九位,以及最多四位小数',
				},
			],
			money1Rule: [
				{ required: true, message: '不能为空...' },
				{
					pattern: /(^[\d]|^[1-9][\d]{0,11})($|[\.][\d]{0,2}$)/,
					message:
						'请填写正确的金额，不能为负数，小数点前最多十二位,以及最多两位小数',
				},
			],
			openLevel: 3, // 展开层级
			levelList: [
				{
					sname: '展开到一级',
					value: 1,
				},
				{
					sname: '展开到二级',
					value: 2,
				},
				{
					sname: '展开到三级',
					value: 3,
				},
				{
					sname: '展开到四级',
					value: 4,
				},
			],
		}
	},
	created() {
		this.showType = this.projectRow.taskType
		this.routeQuery == 'project'
			? (this.packId = this.projectRow.id)
			: (this.packId = this.projectRow.packId)
		// 项目信息
		this.getInfoData()
		// 项目资料
		this.getDataFiles()
		// 标段信息
		this.getSectionForm()
		// 获取当前登录人公司信息
		this.getCompanyMsg()
	},
	methods: {
		// 选中的
		doSelect() {
			this.tableLoading = true
			let selectData = []
			selectData = this.$utils.searchTree(this.reportFileData, (x) =>
				x.fileList.find((y) => y.checked == true)
			)
			this.searchData = selectData
			this.addDialog.show = false
			setTimeout(() => {
				if (this.searchData.length > 0) {
					this.$refs.selectData.setAllTreeExpand(true)
					this.levelChange(this.openLevel)
				}
				this.tableLoading = false
			}, 300)
		},

		// 上传
		doUpload() {
			this.uploadLoaing = true
            this.reportLoading = true

			this.$refs.fileUpload.fileSend(
				this.uploadData.id,
				this.projectRow.projectId,
                () => {
                    this.uploadLoaing = false;
				    this.dialog.show = false;
                    setTimeout(() => {
                        if (this.routeQuery == 'project') {
				        	this.getDataFiles(1)
				        } else {
				        	this.getReportFile(1)
				        }
                    }, 500)
                },
                () => {
                    this.uploadLoaing = false
                }
			)
			
			// setTimeout(() => {
			// 	this.uploadLoaing = false
			// 	this.dialog.show = false
			// 	if (this.routeQuery == 'project') {
			// 		this.getDataFiles(1)
			// 	} else {
			// 		this.getReportFile(1)
			// 	}
			// }, 2000)
		},

		// 取消
		doCancel() {
			this.dialog.title = ''
			this.dialog.type = ''
			this.dialog.show = false
			this.reportLoading = true
			if (this.routeQuery == 'project') {
				this.getDataFiles(1)
			} else {
				this.getReportFile(1)
			}
		},

		// 选择报审资料
		addFile() {
			this.addDialog.title = '选择报审资料'
			this.addDialog.type = 'add'
			this.addDialog.show = true
		},

		// 复选框全选
		selectAllEvent(data) {
			let row = data.records
			if (data.checked) {
				row.forEach((x) => {
					if (x.fileList.length > 0) {
						x.fileList.map((y) => {
							y.checked = data.checked
						})
					}
				})
			} else {
				let arr = this.$utils.filterTree(
					this.reportFileData,
					(x) => x.fileList.length > 0
				)
				arr.forEach((x) => {
					x.fileList.map((y) => {
						y.checked = false
					})
				})
			}
		},

		// 复选框change事件
		selectChangeEvent(data) {
			let row = []
			row.push(data.row)
			let arr = this.$utils.filterTree(row, (x) => x.fileList.length > 0)
			arr.forEach((x) => {
				x.fileList.map((y) => {
					y.checked = data.checked
				})
			})
		},

		// 回显项目信息
		getInfoData() {
			API.getProjectInfo({ id: this.projectRow.projectId }).then(
				(res) => {
					this.projectForm = res.data.projectInfo
					this.contractorsData = res.data.ownerInfo
					this.dealMsg(this.projectForm.intervalPrice, 'zjqj')
				}
			)
		},

		// 根据项目ID 回显附件
		getDataFiles(data) {
			API.getProjectFileData({
				projectId: this.projectRow.projectId || '',
				tableName: 'bus_project',
				source: 'xxx',
				type: '0',
			}).then((res) => {
				this.projectFiles = res.data
				if (this.routeQuery == 'project') {
					this.reportFileData = this.$utils.clone(res.data, true)
				}
				if (data == 1) {
					setTimeout(() => {
						this.$refs.reportTable.setAllTreeExpand(true)
						this.reportLoading = false
					}, 1000)
				}
			})
		},

		// 获取标段信息
		getSectionForm() {
			API.selectPackageInfo({
				packId: this.packId,
			}).then((res) => {
				this.sectionForm = res.data || {}
			})
		},

		// 委托历史获取
		getHistoryInfo() {
			API.entrustHistoryInfo({
				packId: this.packId,
			}).then((res) => {
				this.historyData = res.data || []
			})
		},

		// 获取委托协审单位
		getUnitList(type) {
			let params = {
				limitId: type,
			}
			API.selectentrustUnits(params)
				.then((res) => {
					this.unitList = res.data || []
				})
				.catch((err) => {
					this.unitList = []
				})
		},

		// 确认信息到下一步
		nextStep() {
			this.activeNum = 2
			this.getHistoryInfo()
			this.getUnitList('1382233569480044661')
			if (this.routeQuery != 'project') {
				this.getTaskInfo()
			}
			this.tableLoading = true
			let that = this
			setTimeout(() => {
				if (that.searchData.length > 0 && that.$refs.selectData) {
					that.levelChange(this.openLevel)
				}
				that.tableLoading = false
			}, 300)
		},

		// 获取报审资料（以上传）
		getReportFile(data) {
			API.getTaskFileListByUpdate({
				taskId: this.taskId,
				projectId: this.projectRow.projectId,
				type: '1',
			}).then((res) => {
				this.reportFileData = res.data
				if (data == 1) {
					setTimeout(() => {
						this.$refs.reportTable.setAllTreeExpand(true)
						this.reportLoading = false
					}, 1000)
				} else {
					let arr = this.$utils.clone(res.data, true)
					arr = this.$utils.searchTree(res.data, (x) =>
						x.fileList.find((y) => y.checked == true)
					)
					this.searchData = arr
				}
			})
		},

		// 下载资料
		downloadFile(data) {
			let uploadUrl = ''
			// 本地环境代理后无法直接获取路径
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}

			window.open(this.$previewUrl + previewUrl(uploadUrl + data.filePath), '_blank')
			// window.open(process.env.VUE_APP_UPLOAD_URL + data.filePath)
		},

		// 返回
		backHome() {
			// 从 项目登记 或 我的委托 页面进来返回对应页面
			if (this.routeQuery == 'project') {
				this.$router.push({
					name: 'ProjectIndex',
				})
			} else {
				this.$router.push({
					name: 'CommissionIndex',
				})
			}
		},

		// 甩项change 事件
		hasJiltChange(data) {
			if (data.value == 0) {
				this.formData.jiltAmount = ''
			}
		},

		// 提交审核
		doAudit() {
			this.btnLoading = true
			this.$refs.elForm.validate((valid) => {
				if (valid) {
					let paramsForm = Object.assign({}, this.formData)
					paramsForm.projectId = this.projectRow.projectId
					paramsForm.auditId = this.projectForm.auditId
					paramsForm.tenantId = this.tenantId
					paramsForm.taskType = this.showType
					paramsForm.packId = this.packId
					paramsForm.auditPrice = parseFloat(paramsForm.auditPrice)

					let ApiName = ''
					// taskId 是委托报审内容id 如果没有的就是新增后提交审核
					// 有的话就是编辑后提交审计
					if (this.taskId == '') {
						// 提交申报
						ApiName = 'reportSection'
					} else {
						// 修改
						ApiName = 'againEntrust'
						paramsForm.taskId = this.taskId //任务id
						paramsForm.sponsorUnit = this.userInfo.deptName //发起单位(委托单位)
						paramsForm.taskPrincipal = this.userInfo.sname //单位负责人
						paramsForm.constract = this.userInfo.phone || '' //负责人联系方式
					}
					if (this.searchData.length > 0) {
						API[`${ApiName}`](paramsForm)
							.then((res) => {
								if (
									res.operationCode != 1 ||
									res.msg == 'faild'
								) {
									this.btnLoading = false
									this.$message.error(res.data)
									return
								}
								this.activeNum = 3
								API.saveFiles({
									taskId: res.data
										? res.data.id
										: this.taskId,
									allList: this.searchData,
								})
									.then((res) => {
										this.btnLoading = false
										this.$router.push({
											name: 'CommissionIndex',
										})
									})
									.catch(() => {
										this.btnLoading = false
									})
							})
							.catch(() => {
								this.btnLoading = false
							})
					} else {
						this.btnLoading = false
						this.$message.error('至少关联一个报审资料！')
					}
				} else {
					this.$message.error('请完善表单')
					setTimeout(() => {
						this.btnLoading = false
					}, 1000)
				}
			})
		},

		// 修改信息
		doEdit() {
			let projectId = this.projectRow.projectId
			this.$router.push({
				path: '/projectInfo',
				query: {
					menu: 'project',
					type: 'edit',
					projectId: projectId,
				},
			})
		},

		// 回显委托报审内容
		getTaskInfo() {
			API.commissionBusTaskInfo({
				taskId: this.projectRow.id,
			}).then((res) => {
				this.formData.entrustType = res.data.busTaskOwner.entrustType //委托方式
				this.formData.finishTime = res.data.busTaskOwner.finishTime //要求完成时间
				this.formData.entrustUnit =
					res.data.busTaskOwner.assitantUnit || '' //委托单位
				// 审计任务类型
				this.showType = res.data.busTaskOwner.auditType || ''
				this.formData.auditPrice =
					res.data.busPackageAudit.auditPrice || ''
				this.formData.status = res.data.busPackageAudit.status
				this.formData.confirmType = res.data.busTaskOwner.confirmType
				this.formData.hasJilt = res.data.busPackageAudit.hasJilt
				this.formData.jiltAmount = res.data.busPackageAudit.jiltAmount
				this.formData.completeTime =
					res.data.busPackageAudit.completeTime //计划开工（竣工）时间
				this.formData.remark = res.data.busTaskInfo.remark || ''
				this.formData.entrustType == 0
					? (this.formData.utilType = '协审单位')
					: (this.formData.utilType = '审计单位')
				this.taskId = res.data.busTaskInfo.id //委托报审内容id
				this.formData.entrustType == 0
					? this.getUnitList('1382233569480044661')
					: this.getUnitList('1382233532112990209')
				this.getReportFile()
			})
		},

		// 处理码表
		dealMsg(data, type) {
			let obj = ''
			if (type == 'zjqj') {
				obj = this.projectDict.xmzjqj.find((x) => x.value == data)
				if (obj) {
					this.projectForm.intervalPrice = obj.sname
				}
			}
		},

		// 委托方式change事件
		radioChange(data) {
			data == 1
				? this.getUnitList('1382233532112990209')
				: this.getUnitList('1382233569480044661')
			this.formData.entrustUnit = ''
			this.formData.utilType = ''
			this.formData.confirmType = ''
		},

		// 委托协审单位change事件
		utilChange() {
			this.formData.entrustType == 0
				? (this.formData.utilType = '协审单位')
				: (this.formData.utilType = '审计单位')
		},

		//处理项目状态
		dealStatus(data) {
			let obj = this.projectDict.xmzt.find((x) => x.value == data)
			if (obj) {
				return obj.sname
			}
		},

		// 上传文件
		uploadFile(data) {
			this.uploadData = data
			this.dialog.title = '上传'
			this.dialog.type = 'upload'
			this.dialog.show = true
		},

		// 查看附件
		viewFile(data) {
			this.viewData = data.fileList
			this.dialog.type = 'view'
			this.dialog.title = '查看'
			this.dialog.show = true
		},

		// 获取当前登录人公司信息
		getCompanyMsg() {
			API.selectTenantInformation({
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				this.upUnit = res.data ? res.data.unitName : ''
				this.shortName = res.data ? res.data.shortName : ''
			})
		},

		// 展开层级
		levelChange(level) {
			// 先关闭所有
			this.$refs.selectData.clearTreeExpand()

			// 找到对应层级的数组
			let arr = this.$utils.filterTree(
				this.searchData,
				(x) => x.level < level - 1
			)
			this.$refs.selectData.setTreeExpand(arr, true)
		},
	},
	computed: {
		// 上传附件类型
		acceptType() {
			return ['doc', 'docx', 'xls', 'xlsx', 'pdf']
		},

		// 选中项目数据
		projectRow() {
			return JSON.parse(this.$getSessionItem('projectRow'))
		},

		// 路由type参数
		routeQuery() {
			return this.$route.query.type
		},

		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		...mapState('user', {
			userInfo: (state) => state.userInfo,
			tenantId: (state) => state.tenantId,
		}),

		// 可预览格式
		viewAcceptType() {
			return [
				'jpg',
				'png',
				'pdf',
				'gif',
				'excel',
				'doc',
				'docx',
				'txt',
				'xls',
				'xlsx',
				'ppt',
				'pptx',
				'xml',
			]
		},
	},
	beforeRouteLeave(to, from, next) {
		this.$getSessionItem('projectRow')
			? this.$removeSessionItem('projectRow')
			: ''
		next()
	},
}
</script>
<style lang="less" scoped>
.entrust-layout {
	height: 100%;
	background-color: #fff;
	padding: 10px 0px 0 0px;

	.entrust-layout-header {
		width: calc(~'100% - 10px');
		border-bottom: 1px solid #eee;
		img {
			width: 560px;
		}
	}

	.container {
		height: calc(~'100% - 70px');
		padding: 10px 20px;
		overflow-y: auto;
		.project-msg {
			/deep/ .el-form-item {
				margin-bottom: 0 !important;
			}
			/deep/ .el-form-item__label {
				color: #999;
				padding-right: 5px;
			}
		}
		.green {
			span {
				display: inline-block;
				padding: 0 50px !important;
				background-color: #60adf9;
				color: #fff;
				font-size: 14px;
				font-weight: bold;
				height: 32px;
				line-height: 32px;
			}
		}
		.container-box {
			border: 1px solid #dcdcdd;
			padding: 10px;
			margin-bottom: 20px;
		}
		.entrust-msg {
			.el-form-item {
				margin-bottom: 15px !important;
			}
		}
		.text-color {
			color: #000;
		}
	}
	.area-style {
		display: inline-block;
		line-height: 12px;
	}
	.right-btns {
		position: absolute;
		right: 0;
		top: 66px;
		padding: 0 10px;
		background-color: #fff;
		z-index: 10;
	}

	.blue-text {
		color: blue;
		text-decoration: underline;
		cursor: pointer;
	}
	.pd0 {
		padding: 0 !important;
	}
	.msg-show {
		font-size: 14px;
		color: #999;
		line-height: 32px;
		span {
			color: #000;
		}
	}
	.p-width {
		width: calc(~'100% - 190px');
	}
	.flex {
		p:last-child {
			flex: 1;
		}
	}
	.h400 {
		height: 400px !important;
	}
	.no-data {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #ccc;
		i {
			font-size: 60px;
		}
	}
	.btn {
		padding: 0 50px !important;
	}
	.mr10 {
		margin-right: 10px !important;
	}
	.blue {
		color: #60adf9;
	}
	.overflow-x {
		overflow-x: auto;
	}
}
</style>

<style lang="less">
.vxe-table--tooltip-wrapper {
	z-index: 9999 !important;
}
</style>
